import React, { useState } from 'react';
import { ChevronDoubleDownIcon } from '@heroicons/react/24/outline';

const CustomBlockCard = ({ image, title }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div 
            onMouseEnter={handleMouseEnter} 
            onMouseLeave={handleMouseLeave} 
            className="flex flex-col items-center justify-center mt-5 text-center group"
        >
            <div className=" h-[40px] lg:h-[50px] w-full ">
                <div className='relative flex justify-center '>
                    {/* {isHovered && ( */}
                        <ChevronDoubleDownIcon className="w-6 h-6 md:w-7 md:h-7 text-black absolute top-[0px] opacity-0 group-hover:opacity-100 duration-300 " />
                    {/* )} */}
                </div>
            </div>
            <img
                src={image}
                alt="image"
                className="max-h-[131px] "
            />
            <div
                className={`px-4 mt-2 w-full h-[45px] lg:h-[90px] duration-300 group-hover:bg-black  bg-custom-yellow flex items-center justify-center`}
                >
                <h2 className={` lg:text-lg  text-xs  group-hover:text-white text-black font-bold`}>
                    {title.replace(/\n/g, '<br />')}
                </h2>
            </div>

        </div>
    );
};

export default CustomBlockCard;
